import React from 'react';
import { set } from 'dot-prop-immutable';
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import { SimpleForm as Form, Collapse, Switch } from '@whalecloud/fdx';
import CustomInput from '@whalecloud/page-builder-base-components/components/CustomInput';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';
import CommonColorPicker from '@whalecloud/page-builder-base-components/components/CommonColorPicker';

const { Panel } = Collapse;

const valueKey = 'data.formItemSettings';

const RateSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { data: { formItemSettings = {} } = {} } = element;

  const {
    allowHalf = false,
    count = 5,
    style = {},
  } = formItemSettings;
  const { color = '#fadb14' } = style;
  const initialValues = {
    allowHalf,
    count,
    color,
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      let propName = `${valueKey}.${key}`;
      let relValue = obj[key];
      if (key === 'color') {
        relValue = {
          [key]: obj[key],
        };
        propName = `${valueKey}.style`;
      }
      const newElement = set(element, propName, relValue);
      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
      <Panel header={messages.PAGEBUIDER_SETTINGS} key="1">
        <CommonItemSettings placeholderHide allowClearHide />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_ALLOW_HALF} name="allowHalf" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_COUNT} name="count">
            <CustomInput inputType="inputNumber" />
          </Form.Item>
        </Form>
        <CommonColorPicker />
      </Panel>
    </Collapse>
  );
};

export default RateSettings;
